<div class="invalid-bg d-flex align-items-center justify-content-center">
    <div class="invalid-content d-flex align-items-center justify-content-center flex-wrap">
        <img src="/assets/img/top-logo.png" style="width: 300px;" class="mb-4" alt="RekbotLogo"/>
        <h3>Błąd tokena</h3>
        <span class="pb-2">Token jest niewłaściwy lub wygasł</span>
    </div>
</div>